import { render, staticRenderFns } from "./businessCardLifeCycle.vue?vue&type=template&id=3335520f&"
import script from "./businessCardLifeCycle.vue?vue&type=script&lang=js&"
export * from "./businessCardLifeCycle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports